export default __webpack_public_path__ + "static/media/money-bags-and-coins.163b5cc6.svg";